// OrdersProvider.js
import { createContext, useContext, useState } from "react";

const OrdersContext = createContext(null);

export function OrdersProvider({ children }) {
  const [liveOrders, setLiveOrders] = useState([]);

 const addNewOrder = (order) => {
  setLiveOrders(prev => {
    const incomingId = order.id; // ← this is now the primary unique ID

    // Check if the order already exists in the list
    if (prev.some(o => o.id === incomingId)) {
      return prev; // Don't add it again (prevents duplicates)
    }

    // Prepend the new order to the list
    return [order, ...prev];
  });
};


  const clearLiveOrders = () => setLiveOrders([]);

  return (
    <OrdersContext.Provider value={{ liveOrders, addNewOrder, clearLiveOrders }}>
      {children}
    </OrdersContext.Provider>
  );
}

export function useOrders() {
  const ctx = useContext(OrdersContext);
  if (!ctx) {
    throw new Error("useOrders must be used inside <OrdersProvider>");
  }
  return ctx;
}
